import React, { useState, useEffect } from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import ActiveVSPassive from './components/activevspassive';
import RiskVSReward from './components/riskvsreward';
import AllocationTable from './components/allocations';
import APCommentary from './components/apcommentary';
import KeyFacts from './components/keyfacts';
import PortfolioHoldings from './components/portfolioholdings';
import InvestmentStrategy from './components/investmentstrategy';
import Performance from './components/performance';
import Percentiles from './components/percentiles';
import ListOfFunds from './components/listoffunds';

import './App.css';

const isNumeric = (str) => {
  return /^\d+$/.test(str);
}

//this is wrong - fix it - needs to load in from the URI or just go relatve

//const baseURI = "http://localhost:3000/";
const baseURI = "";

const App = () => {

  const [data, setData] = useState(undefined);

  const pathname = window.location.pathname;
  const search = window.location.search;
  console.info("Pathname: " + pathname + " search: " + search.replace(/\?/g, ''));
  //  let requestedID = window.location.pathname;
  //  if (requestedID === "/nfs") { requestedID = "" };

  // Find the index of the last "/"
  const lastIndex = pathname.lastIndexOf('/');
  // Extract the part before the last "/"
  const firstPart = pathname.substring(0, lastIndex);
  // Extract the part after the last "/"
  const lastPart = pathname.substring(lastIndex + 1);

  console.info("Firstpart: " + firstPart + " lastPart: " + lastPart);

  let requestedID = "";
  if (isNumeric(search.replace(/\?/g, ''))) {
    requestedID = search.replace(/\?/g, '');
  };

  console.info("requestedID outside useEffect: " + requestedID);
  useEffect(() => {
    console.info("requestedID inside useEffect: " + requestedID);
    let URI = "";
    if (requestedID && requestedID.length > 1) {
      URI = firstPart + lastPart + "/input/" + requestedID + ".json";
    } else {
      // There is no share class ID in the URL, so load in the index json file.
      URI = firstPart + lastPart + "/input/index.json";
    }
    console.info("URI being requested is : " + URI);
    fetch(URI)
      .then((res) => res.json())
      .then((data) => {
        console.info("Data is downloaded.");
        console.info("Length is: " + data.length);
        console.info("Downloaded Data is :" + JSON.stringify(data));
        setData(data);
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });

  }, [pathname, firstPart, requestedID]);

  if (requestedID.length < 2) {
    // create the indez.
    if (data && typeof data !== 'undefined') {
      return <ListOfFunds data={data} />
    } else {
      return (<p>Loading data . . .</p>);
    }
  } else {
    const logoStyle = {
      width: "300px",
      border: "-50px -50px -50px -50px"
    };

    if (data && typeof data !== 'undefined') {
      return (<Container className="p-3">
        {/* Header */}
        <Row>
          <Col xs={9}><h1 className="header">{data.fundsaiqanalysis.Name}</h1></Col>
          <Col xs={3}><a href={firstPart + lastPart}><img src="logo.png" style={logoStyle} alt="FundsAIQ x horatio.ai logo"/></a></Col>
        </Row>
        {/* Wide graph should go here. */}
        <Row>
          <Col xs={12}>
            <APCommentary data={data.fundSummary} />
            <ActiveVSPassive data={data.charts} />
            <RiskVSReward data={data.charts} />
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            {/* Left column - metrics , holdings and performance*/}
            <Percentiles data={data.fundsaiqanalysis} />
            <KeyFacts data={data.metrics} />
            <PortfolioHoldings data={data.portfolioHoldings} />
            <Performance data={data.performance} />
          </Col>
          <Col xs={6}>
            {/* Right column*/}
            <Row><AllocationTable data={data.sectorallocation} /></Row>
            <Row><AllocationTable data={data.assetTypeAllocation} /></Row>
            <Row><AllocationTable data={data.currencyAllocation} /></Row>
          </Col>
        </Row>
        <Row>
          {/*  Investment strategy which spans across the page. */}
          <InvestmentStrategy data={data.metrics.fund_investment_strategy} />
        </Row>
      </Container>);
    } else {
      return (<p>Loading data . . .</p>);
    }
  }
};

export default App;
